<template>
    <div class="relative bg-wrap-color">
        <template v-if="isPageAllowed">
            <div class="bg-color" style="padding-bottom: 10px;transition: none;" v-show="!ads_show">
                <div class="tab-bar relative">
                    <el-tabs v-model="activeTabName" @tab-click="changeTab">
                        <el-tab-pane label="广告系列组" name="apple_org" v-if="pageActionNames.includes('apple_org')">
                            <OrgPage v-if="activeTabName == 'apple_org'" ref="apple_org" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="pageFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action-names="pageActionNames" @to-page="toPage"/>
                        </el-tab-pane>
                        <el-tab-pane label="广告系列" name="apple_campaign" v-if="pageActionNames.includes('apple_campaign')">
                            <CampaignPage v-if="activeTabName == 'apple_campaign'" ref="apple_campaign" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="pageFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action-names="pageActionNames" @click-add="handleClickAddCampaign" @to-page="toPage"/>
                        </el-tab-pane>
                        <el-tab-pane label="广告组" name="apple_adgroup" v-if="pageActionNames.includes('apple_adgroup')">
                            <AdGroup v-if="activeTabName == 'apple_adgroup'" ref="apple_adgroup" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="pageFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action-names="pageActionNames" @click-add="handleClickAddGroup" @to-page="toPage"/>
                        </el-tab-pane>
                        <el-tab-pane label="关键词" name="keywords" v-if="isHasKeywordTabs">
                            <Keywords v-if="activeTabName == 'keywords'" ref="keywords" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="pageFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action="pageAction" :page-action-names="pageActionNames" @to-page="toPage"/>
                        </el-tab-pane>
                        <el-tab-pane label="广告" name="apple_ad" v-if="pageActionNames.includes('apple_ad')">
                            <AdPage v-if="activeTabName == 'apple_ad'" ref="apple_ad" :mixin-loading="mixinLoading" :page-dimension="pageDimension" :page-fields="pageFields" :page-func="pageFunc" :zone="timeZone" :range-time="range_time" :page-action-names="pageActionNames" @to-page="toPage"/>
                        </el-tab-pane>
                        <el-tab-pane label="A/B测试" name="apple_ad_test" v-if="pageActionNames.includes('apple_ad')">
                            <AdPageTest v-if="activeTabName == 'apple_ad_test'" ref="apple_ad_test" :mixin-loading="mixinLoading" :zone="timeZone" :range-time="range_time" />
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <TimeZone v-show="!ads_show" class="inline-block time-zone" :zone="timeZone" @change="updateZone" :range-time="range_time" :page-func-names="pageFuncNames" @click-add="AddAd" :add-loading="addLoading"/>
            
            <CreateAds v-if="ads_show" ref="createAds" @adsClose="handleadsClose"></CreateAds>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>Apple广告投放平台</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {pageMixin} from './pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import OrgPage from './org/index';
    import CampaignPage from './campaign/index';
    import AdGroup from './adGroup/index';
    import Keywords from './keywords/index';
    import CreateAds from './create/index';
    import AdPage from './ad/index';
    import AdPageTest from './ad/test';


    import TimeZone from './components/timeZone';
    import API from '@/api/marketManage/apple/index';
    import dayjs from 'dayjs';
    import {handleDocumentNoctiyClick} from "./components/getFlagHtml.js";
    export default {
        name: "AppleIndexZH",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            OrgPage,
            CampaignPage,
            TimeZone,
            AdGroup,
            Keywords,
            CreateAds,
            AdPage,
            AdPageTest,
        },
        data() {
            return {
                isPageAllowed: true,
                activeTabName:'',
                timeZone:'',
                range_time:[],
                routeTabNames:[],
                ads_show: false,  //创建广告
                addLoading:false,
                priceDecimalConfig:[],
            }
        },
        provide(){
            return {
                priceDecimalConfig:this.getPriceDecimalConfig,
            }
        },
        computed:{
            ...mapGetters(['tabs_map', 'apple_create_type']),
            pageFunc(){
                if(this.activeTabName=='keywords'){
                    let pageData = this.pageAction.find(item=>item.name=='apple_keyword'||item.name=='apple_search_term'||item.name=='apple_negative_keyword')||{};
                    return pageData.func||[];
                }else{
                    let pageData = this.pageAction.find(item=>item.name==this.activeTabName)||{};
                    return pageData.func||[];
                }
            },
            pageFields(){
                if(this.activeTabName=='keywords'){
                    let pageData = this.pageAction.find(item=>item.name=='apple_keyword'||item.name=='apple_search_term'||item.name=='apple_negative_keyword')||{};
                    return pageData.fields||[];
                }else{
                    let pageData = this.pageAction.find(item=>item.name==this.activeTabName)||{};
                    return pageData.fields||[];
                }
            },
            pageDimension(){
                if(this.activeTabName=='keywords'){
                    let pageData = this.pageAction.find(item=>item.name=='apple_keyword'||item.name=='apple_search_term'||item.name=='apple_negative_keyword')||{};
                    return pageData.dimension||[];
                }else{
                    let pageData = this.pageAction.find(item=>item.name==this.activeTabName)||{};
                    return pageData.dimension||[];
                }
            },
            isHasKeywordTabs(){
                let hasKeyword = this.pageActionNames.includes('apple_keyword');
                let hasSearchTerm = this.pageActionNames.includes('apple_search_term');
                let hasNegativeKeyword = this.pageActionNames.includes('apple_negative_keyword');
                return hasKeyword||hasSearchTerm||hasNegativeKeyword;
            },
            pageActionNames(){
                let tabsMap =  this.tabs_map||{};
                let apple =tabsMap.apple||[];
                return apple.map(item=>item.name);
            },
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
        },
        watch: {
            apple_create_type: {
                handler(val, oldVal) {
                    if(val == 'createOrg' || val == 'editOrg') {
                        this.activeTabName = 'apple_campaign'
                    }else if(val == 'createGroup' || val == 'editGroup') {
                        this.activeTabName = 'apple_adgroup'
                    }
                },
                deep: true, // 深度监听
            }
        },
        mounted(){
            document.addEventListener('click', handleDocumentNoctiyClick);

            let routeParams = this.$route.params||{};
            let routeName = this.$route.name;
            if(['apple_keyword','apple_search_term','apple_negative_keyword'].includes(routeName)){
                this.activeTabName = 'keywords';
            }else{
                this.activeTabName = 'apple_org';
            }

            this.$store.commit('apple/SET_CUR_TAB_PAGE',this.activeTabName);
            if(!routeParams.range){
                let today = dayjs().format('YYYY-MM-DD');
                this.range_time = [today,today];
            }else{
                this.range_time = [...routeParams.range];
            }
            if(routeParams.zone){
                this.timeZone = routeParams.zone;
            }
            this.getTimeZone();

            /* 2024.11.28 临时测试效果，勿合  zql*/
            // 此处判断页面是否需要隐藏侧边栏&顶栏
            let isHideTdBar = true;
            if(isHideTdBar){
                this.hideTdBar();
            }
            this.getPriceDecimalPlacesConfig();
        },
        methods:{
            getPriceDecimalConfig(){
                return this.priceDecimalConfig;
            },
            async getPriceDecimalPlacesConfig(){
                await API.getPriceDecimalPlacesConfig().then(res=>{
                    console.log(res,'getPriceDecimalPlacesConfig');
                    this.priceDecimalConfig = res.data||[];
                },err=>{
                    console.log(err,'getPriceDecimalPlacesConfig err');
                    this.priceDecimalConfig = [];
                })
            },
            /* 2024.11.28  临时测试效果，勿合  zql*/
            hideTdBar(){
                $('body').addClass('jt-td-special-page-hide-menu');
            },
            showTdBar(){
                $('body').removeClass('jt-td-special-page-hide-menu');
            },


            changeTab(tab){
                window.scrollTo(0, 0);
                let tabName = tab.name||'';
                
                let isHasKeywordTab = this.pageActionNames.includes('apple_keyword');
                let isHasSearchTermTab = this.pageActionNames.includes('apple_search_term');
                let isHasNegativeKeywordTab = this.pageActionNames.includes('apple_negative_keyword');
                let defaultPage = 'home';
                if(isHasKeywordTab){
                    defaultPage = 'apple_keyword';
                }else if(isHasSearchTermTab){
                    defaultPage = 'apple_search_term';
                }else if(isHasNegativeKeywordTab){
                    defaultPage = 'apple_negative_keyword';
                }
            },
            initPageStates(){
                console.log('initPageStates');
                console.log('pageFunc',this.pageFunc);
                console.log('pageFields',this.pageFields);
            },
            getTimeZone(){
                API.getTimeZone().then(res=>{
                    let resData = res.data||{};
                    this.timeZone = resData.time_zone||'Asia/Shanghai';
                })
            },
            updateZone(zone,range){
                console.log('updateZone',zone,range);
                this.range_time = range;
                this.timeZone = zone;
                this.$nextTick(()=>{
                    if(this.activeTabName == 'keywords'){
                        this.$refs.keywords.updateZone();
                    }else{
                        this.$refs[this.activeTabName].getSearchList();
                    }
                });

                API.setTimeZone({
                    time_zone:zone,
                }).then(res=>{

                    console.log('setTimeZone',res);
                },err=>{
                    this.$message.error(err.info||'修改失败');
                });
            },
            // 创建广告
            AddAd(){
                // let routeParams = this.$route.params||{};
                let routeName = this.activeTabName;
                // let routeName = this.$route.name;
                console.log(routeName);

                if(routeName=='keywords'){
                    let $keywordsRef = this.$refs.keywords;
                    console.log('$keywordsRef',$keywordsRef);
                    routeName = $keywordsRef.activeTabName;
                }



                let typeMap = {
                    apple_org:'org_add_ad',
                    apple_campaign:'campaign_add_ad',
                    apple_adgroup:'adgroup_add_ad',
                    apple_keyword:'keyword_add_ad',
                    apple_search_term:'search_term_add_ad',
                    apple_negative_keyword:'negative_keyword_add_ad',
                    apple_ad:'ad_add_ad',
                };
                let urlName = typeMap[routeName];
                if(urlName){
                    this.addLoading = true;
                    API['check_'+urlName]().then(()=>{
                        this.addLoading = false;
                        this.$store.commit('apple/SUBMIT_URL_NAME',urlName);
                        if(urlName == 'apple_adgroup') {
                            this.$store.commit('apple/SET_CREATE_TYPE','createGroup');
                        }else{
                            this.$store.commit('apple/SET_CREATE_TYPE','createOrg');
                        }
                        this.ads_show = true;
                    },err=>{
                        this.$message.error(err.info||'请求失败');
                        this.addLoading = false;
                    })

                }else{
                    this.addLoading = false;
                    this.$message.error('操作有误');
                }

            },
            handleadsClose(params) {
                window.scrollTo(0, 0);
                this.ads_show = false
                if(params.name == 'createGroup') {
                    // this.activeTabName = 'apple_adgroup'
                    this.$nextTick(()=>{
                        this.$store.commit('apple/RESET_LIST_PAGE_QUERY');
                        this.changeTab({
                            name:'apple_adgroup',
                        });
                    });
                    if(this.activeTabName=='apple_adgroup'){
                        this.$store.commit('apple/IS_RELOAD_LIST');
                    }
                }else if(params.name == 'createOrg') {
                    // this.activeTabName = 'apple_campaign'
                    this.$nextTick(()=>{
                        this.$store.commit('apple/RESET_LIST_PAGE_QUERY');
                        this.changeTab({
                            name:'apple_campaign',
                        });
                    });
                    if(this.activeTabName=='apple_campaign'){
                        this.$store.commit('apple/IS_RELOAD_LIST');
                    }
                }

            },
            handleClickAddGroup() {
                this.ads_show = true;
            },
            handleClickAddCampaign(type,data){
                this.ads_show = true;
            },
            toPage(page,data){
                console.log('toPage',page,data);
                if(page=='apple_keyword'||page=='apple_keyword'||page=='apple_keyword'){
                    this.activeTabName = 'keywords';
                }else{
                    this.activeTabName = page;
                }
                this.$store.commit('apple/SET_LIST_PAGE_QUERY',data);
            },
        },

        /* 2024.11.28  临时测试效果，勿合  zql*/
        beforeDestroy() {
            this.showTdBar();
        },

    }
</script>

<style lang="scss" scoped>
    .tab-bar::after{
        content: '';
        position: absolute;
        left: -20px;
        right: -20px;
        background-color: #fff;
    }
    .tab-bar ::v-deep .el-tabs__header{
        background-color: #fff;
        margin-bottom: 10px;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .tab-bar ::v-deep .el-tab-pane{
        margin: 0 15px;
    }

    .bg-wrap-color{
        padding: 0;
        background-color:#F1F4F9;
    }

    .time-zone{
        position: absolute;
        right: 20px;
        top: 5px;
    }

    ::v-deep .el-tabs__item.is-active.is-disabled{
        color: #409EFF;
    }
</style>
